export default "__VITE_ASSET__e0613cf3__"